(function () {
function $6a39f8e3db26b6be$export$7669482c90f5c50f(el) {
    el?.classList?.add("isHidden");
    el?.setAttribute("aria-hidden", "true");
}
function $6a39f8e3db26b6be$export$998191bfdf710c72(el) {
    el?.classList?.remove("isHidden");
    el?.setAttribute("aria-hidden", "false");
}




const $c9a4e59f407c2139$var$body = document.querySelector("body");
const $c9a4e59f407c2139$var$loader = document.querySelector(".loader");
function $c9a4e59f407c2139$export$56525cbb1fcd885c() {
    $c9a4e59f407c2139$var$body?.classList.add("isLoading");
    (0, $6a39f8e3db26b6be$export$998191bfdf710c72)($c9a4e59f407c2139$var$loader);
}
function $c9a4e59f407c2139$export$5cee2c2772922923() {
    $c9a4e59f407c2139$var$body?.classList.remove("isLoading");
    (0, $6a39f8e3db26b6be$export$7669482c90f5c50f)($c9a4e59f407c2139$var$loader);
}


window.addEventListener("load", ()=>{
    (0, $c9a4e59f407c2139$export$5cee2c2772922923)();
});



var $d2a2f13126b078cb$require$showElement = $6a39f8e3db26b6be$export$998191bfdf710c72;
var $d2a2f13126b078cb$require$hideElement = $6a39f8e3db26b6be$export$7669482c90f5c50f;
const $d2a2f13126b078cb$var$headerLangRef = document.querySelector("header [data-lang]");
const $d2a2f13126b078cb$var$burgerMenuLangRef = document.querySelector(".burger-menu [data-lang]");
$d2a2f13126b078cb$var$headerLangRef?.addEventListener("click", $d2a2f13126b078cb$var$onLangClick);
$d2a2f13126b078cb$var$burgerMenuLangRef?.addEventListener("click", $d2a2f13126b078cb$var$onLangClick);
function $d2a2f13126b078cb$var$onLangClick(e) {
    if (!e.target.hasAttribute("data-lang-btn")) return;
    const currentLangRef = e.currentTarget;
    const allLangBtnsRef = currentLangRef?.querySelectorAll("[data-lang-btn]");
    const isActive = currentLangRef?.classList.contains("active");
    if (!isActive) return currentLangRef?.classList.add("active");
    const currentLang = currentLangRef.dataset.lang;
    const newLang = e.target.dataset.langBtn || "ua";
    if (currentLang === newLang) return currentLangRef?.classList.remove("active");
    currentLangRef?.classList.remove("active");
    allLangBtnsRef.forEach((i)=>{
        i.classList.contains("isHidden") ? $d2a2f13126b078cb$require$showElement(i) : $d2a2f13126b078cb$require$hideElement(i);
    });
    const currentPath = window.location.pathname; // Отримуємо поточний шлях без домену
    let newUrl = "";
    // Логіка для зміни URL залежно від мови
    if (newLang === "ua") // Якщо мова українська, видаляємо будь-який мовний префікс
    newUrl = currentPath.replace(/^\/(en|ru|de)/, ""); // видаляє /en, /fr, /de тощо з початку шляху
    else // Якщо мова не українська, додаємо мовний префікс
    newUrl = `/${newLang}${currentPath}`;
    // Оновлюємо URL
    window.location.href = newUrl;
}



const $309f797c45c7df1f$var$bodyRef = document.querySelector("body");
const $309f797c45c7df1f$var$burgerMenuRef = document.querySelector("[data-burger-menu]");
const $309f797c45c7df1f$var$burgerMenuBtnRef = document.querySelector("[data-burger-menu-btn]");
$309f797c45c7df1f$var$updateSize();
window.addEventListener("resize", $309f797c45c7df1f$var$updateSize);
$309f797c45c7df1f$var$burgerMenuBtnRef?.addEventListener("click", $309f797c45c7df1f$var$toggleBurgerMenu);
function $309f797c45c7df1f$var$toggleBurgerMenu() {
    const expanded = $309f797c45c7df1f$var$burgerMenuBtnRef?.getAttribute("aria-expanded") === "true" || false;
    if (expanded) (0, $6a39f8e3db26b6be$export$7669482c90f5c50f)($309f797c45c7df1f$var$burgerMenuRef);
    else (0, $6a39f8e3db26b6be$export$998191bfdf710c72)($309f797c45c7df1f$var$burgerMenuRef);
    $309f797c45c7df1f$var$bodyRef?.classList.toggle("burgerMenuIsOpen");
    $309f797c45c7df1f$var$burgerMenuBtnRef?.setAttribute("aria-expanded", !expanded);
}
function $309f797c45c7df1f$var$hideBurgerMenu() {
    (0, $6a39f8e3db26b6be$export$7669482c90f5c50f)($309f797c45c7df1f$var$burgerMenuRef);
    $309f797c45c7df1f$var$bodyRef?.classList.remove("burgerMenuIsOpen");
    $309f797c45c7df1f$var$burgerMenuBtnRef?.setAttribute("aria-expanded", false);
}
function $309f797c45c7df1f$var$updateSize() {
    const innerWidth = window.innerWidth;
    if (innerWidth <= 1280) $309f797c45c7df1f$var$hideBurgerMenu();
// else showBurgerMenu();
}



const $9cddb3e16ef9bc3a$var$bodyRef = document.querySelector("body");
const $9cddb3e16ef9bc3a$var$locationMenuRef = document.querySelector("[data-location-menu]");
const $9cddb3e16ef9bc3a$var$locationMenuBtnRef = document.querySelector("[data-location-menu-btn]");
$9cddb3e16ef9bc3a$var$locationMenuBtnRef?.addEventListener("click", $9cddb3e16ef9bc3a$var$toggleLocationMenu);
$9cddb3e16ef9bc3a$var$locationMenuRef?.addEventListener("click", $9cddb3e16ef9bc3a$var$onLocationMenuClick);
function $9cddb3e16ef9bc3a$var$toggleLocationMenu() {
    const expanded = $9cddb3e16ef9bc3a$var$locationMenuBtnRef.getAttribute("aria-expanded") === "true" || false;
    if (expanded) (0, $6a39f8e3db26b6be$export$7669482c90f5c50f)($9cddb3e16ef9bc3a$var$locationMenuRef);
    else (0, $6a39f8e3db26b6be$export$998191bfdf710c72)($9cddb3e16ef9bc3a$var$locationMenuRef);
    $9cddb3e16ef9bc3a$var$bodyRef.classList.toggle("locationMenuIsOpen");
    $9cddb3e16ef9bc3a$var$locationMenuBtnRef.setAttribute("aria-expanded", !expanded);
}
function $9cddb3e16ef9bc3a$var$onLocationMenuClick(e) {
    if (!e.target.hasAttribute("data-location-btn")) return;
    // Визначаємо поточну та нову локації
    const currentLocation = $9cddb3e16ef9bc3a$var$locationMenuBtnRef?.parentElement?.dataset.location;
    const newLocation = e.target.dataset.locationBtn;
    // якщо кліп на поточну локацію, то закриваємо меню
    if (currentLocation === newLocation) return $9cddb3e16ef9bc3a$var$hideLocationMenu();
    // Отримуємо поточний шлях без домену
    const currentPath = window.location.pathname;
    let newUrl = currentPath;
    // Визначаємо мову з currentPath: якщо починається з /ru/, мова російська, інакше - українська
    const isRussian = newUrl.startsWith("/ru/");
    // Видаляємо мовний префікс, якщо він є
    if (isRussian) newUrl = newUrl.replace(/^\/ru/, ""); // Видаляємо /ru з початку шляху
    // Перевіряємо, чи newUrl не дорівнює "/", "/offices", "/team"
    if (newUrl !== "/" && newUrl !== "/offices" && newUrl !== "/kyiv/offices" && newUrl !== "/team" && newUrl !== "/kyiv/team") {
        newUrl = isRussian ? "/ru/" : "/"; // Встановлюємо newUrl на "/" або "/ru/"
        // Оновлюємо URL
        return window.location.href = newUrl;
    }
    // Видаляємо попередній префікс місця (dnipro або kyiv) з початку шляху
    newUrl = newUrl.replace(/^\/(dnipro|kyiv)/, "");
    // Додаємо новий префікс місця
    if (newLocation === "kyiv") newUrl = `/kyiv${newUrl}`; // для dnipro префікс не додаємо, оскільки це "за замовчуванням"
    // Додаємо назад мовний префікс, якщо мова російська
    if (isRussian) newUrl = `/ru${newUrl}`;
    // Якщо шлях вийде порожнім (наприклад, лише / або /ru/), додаємо кореневий шлях /
    if (newUrl === "" || newUrl === "/ru") newUrl = isRussian ? "/ru/" : "/";
    // Оновлюємо URL
    window.location.href = newUrl;
}
function $9cddb3e16ef9bc3a$var$hideLocationMenu() {
    (0, $6a39f8e3db26b6be$export$7669482c90f5c50f)($9cddb3e16ef9bc3a$var$locationMenuRef);
    $9cddb3e16ef9bc3a$var$bodyRef.classList.remove("locationMenuIsOpen");
    $9cddb3e16ef9bc3a$var$locationMenuBtnRef.setAttribute("aria-expanded", false);
}



var $0bc9a3b7aacc029f$require$showElement = $6a39f8e3db26b6be$export$998191bfdf710c72;
var $0bc9a3b7aacc029f$require$hideElement = $6a39f8e3db26b6be$export$7669482c90f5c50f;
const $0bc9a3b7aacc029f$var$bookingForm = document.forms.bookingForm;
const $0bc9a3b7aacc029f$var$nameInput = $0bc9a3b7aacc029f$var$bookingForm?.elements.name;
const $0bc9a3b7aacc029f$var$phoneInput = $0bc9a3b7aacc029f$var$bookingForm?.elements.phone;
const $0bc9a3b7aacc029f$var$nameError = document?.getElementById("nameError");
const $0bc9a3b7aacc029f$var$phoneError = document?.getElementById("phoneError");
$0bc9a3b7aacc029f$var$bookingForm?.addEventListener("submit", $0bc9a3b7aacc029f$var$onFormSubmit);
$0bc9a3b7aacc029f$var$nameInput?.addEventListener("input", function(e) {
    const nameValue = e.target.value;
    $0bc9a3b7aacc029f$var$nameError.textContent = $0bc9a3b7aacc029f$var$validateName(nameValue);
});
$0bc9a3b7aacc029f$var$phoneInput?.addEventListener("input", function(e) {
    const phoneValue = e.target.value;
    $0bc9a3b7aacc029f$var$phoneError.textContent = $0bc9a3b7aacc029f$var$validatePhone(phoneValue);
});
$0bc9a3b7aacc029f$var$nameInput?.addEventListener("keypress", $0bc9a3b7aacc029f$var$handleNameKeyPress);
$0bc9a3b7aacc029f$var$phoneInput?.addEventListener("keypress", $0bc9a3b7aacc029f$var$handlePhoneKeyPress);
function $0bc9a3b7aacc029f$var$onFormSubmit(e) {
    e.preventDefault();
    const nameValidationError = $0bc9a3b7aacc029f$var$validateName($0bc9a3b7aacc029f$var$nameInput?.value);
    const phoneValidationError = $0bc9a3b7aacc029f$var$validatePhone($0bc9a3b7aacc029f$var$phoneInput?.value);
    if (!nameValidationError && !phoneValidationError) {
        $0bc9a3b7aacc029f$var$sendMail(e.target);
        e.target.reset();
    } else {
        // Відображаємо помилки
        $0bc9a3b7aacc029f$var$nameError.textContent = nameValidationError;
        $0bc9a3b7aacc029f$var$phoneError.textContent = phoneValidationError;
    }
}
async function $0bc9a3b7aacc029f$var$sendMail(formRef) {
    const formData = new FormData(formRef);
    const pageTitle = document.title; // Отримуємо назву сторінки
    const pageUrl = window.location.href; // Отримуємо Url сторінки
    formData.append("title", pageTitle); // Додаємо назву сторінки
    formData.append("url", pageUrl); // Додаємо Url сторінки
    let sendURL = "/sendmail.php";
    const msgSuccess = formRef?.querySelector("[data-response=success]");
    const msgError = formRef?.querySelector("[data-response=error]");
    // showLoader();
    try {
        let response = await fetch(sendURL, {
            method: "POST",
            body: formData
        });
        if (response.ok) $0bc9a3b7aacc029f$require$showElement(msgSuccess);
        else $0bc9a3b7aacc029f$require$showElement(msgError);
    } catch (exceptionVar) {
        $0bc9a3b7aacc029f$require$showElement(msgError);
    } finally{
        // hideLoader();
        const hideMsg = setTimeout(()=>{
            // hideElement(formRef);
            $0bc9a3b7aacc029f$require$hideElement(msgError);
            $0bc9a3b7aacc029f$require$hideElement(msgSuccess);
            clearTimeout(hideMsg);
        }, 5000);
    }
}
function $0bc9a3b7aacc029f$var$validateName(name) {
    // Визначаємо мову з currentPath: якщо починається з /ru/, мова російська, інакше - українська
    const isRussian = window.location.pathname.startsWith("/ru/");
    const erroText1 = isRussian ? "\u0418\u043C\u044F \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C" : "\u0406\u043C'\u044F \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C.";
    const erroText2 = isRussian ? "\u0418\u043C\u044F \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u043A\u0432\u044B." : "\u0406\u043C'\u044F \u043C\u043E\u0436\u0435 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0442\u0456\u043B\u044C\u043A\u0438 \u043B\u0456\u0442\u0435\u0440\u0438.";
    if (!name) return erroText1;
    const regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ']+$/u;
    return regex.test(name) ? "" : erroText2;
}
function $0bc9a3b7aacc029f$var$validatePhone(phone) {
    // Визначаємо мову з currentPath: якщо починається з /ru/, мова російська, інакше - українська
    const isRussian = window.location.pathname.startsWith("/ru/");
    const erroText1 = isRussian ? "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C." : "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C.";
    const erroText2 = isRussian ? "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0446\u0438\u0444\u0440\u044B \u0438 +" : "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u043C\u043E\u0436\u0435 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0442\u0456\u043B\u044C\u043A\u0438 \u0446\u0438\u0444\u0440\u0438 \u0442\u0430 +";
    if (!phone) return erroText1;
    const regex = /[0-9+]/;
    return regex.test(phone) ? "" : erroText2;
}
function $0bc9a3b7aacc029f$var$handleNameKeyPress(e) {
    const regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ']$/u;
    const char = String.fromCharCode(e.charCode);
    if (!regex.test(char)) e.preventDefault();
}
function $0bc9a3b7aacc029f$var$handlePhoneKeyPress(e) {
    const regex = /[0-9+]/;
    const char = String.fromCharCode(e.charCode);
    if (!regex.test(char)) e.preventDefault();
}



})();
//# sourceMappingURL=index.b20f7773.js.map
